// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "organization-summaryleakageflow{top:0;left:0;right:0;display:block;height:90%}organization-summaryleakageflow provider-geoflow{height:100%;width:100%;display:block}\n", ""]);
// Exports
module.exports = exports;
